import moment from 'moment'
import {
  FirebaseMessageData,
  NotificationItem,
  NotificationPayloadExtra
} from './types'

export const getIsFirstOfTheDay = (
  prev: NotificationItem,
  current: NotificationItem
) => moment(current.created_at).date() > moment(prev.created_at).date()

export const getIsToday = (date: string) => moment().isSame(moment(date), 'day')

export const withExtraQuery = (
  path: string,
  extra?: NotificationPayloadExtra | null
) => {
  if (!path || !extra) return path

  const [pathname, search = ''] = path.split('?')
  const params = new URLSearchParams(search)

  Object.entries(extra).forEach(([key, value]) => {
    if ((typeof value === 'string' || typeof value === 'number') && value) {
      params.set(key, String(value))
    }
  })

  const query = params.toString()

  return query ? `${pathname}?${query}` : path
}

export const formatFirebaseResponse = (
  data: FirebaseMessageData,
  id: string
): NotificationItem => ({
  title: data.title,
  description: data.description,
  created_at: data.created_at,
  type: data.type,
  uuid: id,
  recipient: '',
  producer: '',
  is_read: false,
  payload: JSON.parse(data.payload)
})
